import * as yup from 'yup'
import MobileNumberValidator from './MobileNumberValidator'

export type ValidationSchemaKey = 'contactNumber' | 'jobTitle'

/**
 * An object containing Yup validation schemas for different fields.
 * 
 * @type {Object.<ValidationSchemaKey, yup.ObjectSchema<any> | yup.BaseSchema>}
 */
const validationSchemas: { [key in ValidationSchemaKey]: yup.ObjectSchema<any> | yup.BaseSchema } = {
  contactNumber:  MobileNumberValidator().getValidator() as yup.BaseSchema,
  jobTitle: yup.object({
    jobTitle: yup.string().required('Please enter your job title').max(100)
  })
}

/**
 * Validates a value based on the provided validation schema key.
 * 
 * @param {ValidationSchemaKey} key - The key corresponding to the validation schema.
 * @param {string} value - The value to be validated.
 * @returns {string} - The validation error message, if any.
 */
export const validate = (key: ValidationSchemaKey, value: string): string => {
  try {
    validationSchemas[key].validateSync({ [key]: value })
  } catch (untypedError: unknown) {
    const errorObject = untypedError as yup.ValidationError
    return errorObject.message
  }
  return ''
}